import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IMAGE_CONSTANT, TOUR_TARGET_ELEMENT } from '../../constants/app';
import LazyImage from '../../ui-core/Image';
import { isLoggedIn } from '../../utils/helpers';
import { APP_ROUTES } from '../../route';
import { fetchCommunityProfileRequest } from '../../store/action/community';

const ProfileImage = ({ className, history }) => {
  const dispatch = useDispatch();
  const communityProfile = useSelector(state => state.community?.profile);
  const userImage =
    communityProfile?.avatar_url || IMAGE_CONSTANT.defaultProfileIcon;

  useEffect(() => {
    if (isLoggedIn() && !communityProfile) {
      dispatch(fetchCommunityProfileRequest());
    }
  }, [dispatch, communityProfile]);

  const handleClick = () => history.push(APP_ROUTES.PROFILE);

  const handleError = () => {
    if (isLoggedIn()) {
      dispatch(fetchCommunityProfileRequest());
    }
  };

  return (
    <LazyImage
      className={className}
      dataTourId={TOUR_TARGET_ELEMENT.profile}
      errorSrc={IMAGE_CONSTANT.defaultProfileIcon}
      placeholderSrc={IMAGE_CONSTANT.personIcon}
      onClick={handleClick}
      onError={handleError}
      src={userImage}
    />
  );
};

ProfileImage.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};

export default withRouter(ProfileImage);
